module.exports = __webpack_public_path__ + "static/media/danny-green.58681056.jpg";